export const prepareTMTH = (tmth, timzone) => {
  let temp = []
  let value = tmth
  if (!value) return
  value.map((el) => {
    let interval = timzone.find((interval) => interval.id === Number(el))
    temp.push(interval)
  })
  return temp
}

export const reverseTMTH = (tmth, timzone) => {
  let temp = []
  let value = tmth
  if (!value) return
  value.map((el) => {
    let interval = timzone.find((interval) => interval.from === el.from && interval.to === el.to)
    if (interval) temp.push(interval.id)
  })
  return temp
}

export const aiRedeemTermIntervals = () => {
  return [
    { id: 0, from: null, to: null },
    { id: 1, from: 0, to: 1 },
    { id: 2, from: 1, to: 2 },
    { id: 3, from: 2, to: null },
  ]
}

export const filterEmptyKeyValuePairs = (obj) => {
  return Object.keys(obj).length == 0
    ? obj
    : Object.fromEntries(
        Object.entries(obj).filter(([_, v]) => (!Array.isArray(v) && v != null) || (Array.isArray(v) && v.length > 0))
      )
}

export const formatNullValues = (values) => {
  if (!Array.isArray(values)) return null

  let key
  let index

  if (values.indexOf(null) !== -1) {
    key = null
  }
  if (values.indexOf('null') !== -1) {
    key = 'null'
  }

  index = values.indexOf(key)

  if (typeof index === 'number' && index !== -1) {
    values[index] = typeof values[index] === 'string' ? null : 'null'
  }
  return values
}

export const filterByWord = (array, queryString) => {
  return array.filter(
    (el) =>
      (el.issuerName && el.issuerName.toLowerCase().includes(queryString.toLowerCase())) ||
      el.productName.toLowerCase().includes(queryString.toLowerCase())
  )
}

export const filterByIssuerCode = (array, selectedOptions) => {
  return array.filter((el) => selectedOptions.includes(el.issuerCode))
}

export const filterByCompatibility = (array, selectedOptions) => {
  return array.filter((el) => selectedOptions.includes(el.compatibilityType.toString()))
}

export const filterByScoreValue = (array, min, max) => {
  return array.filter((el) => el.score >= min && el.score <= max)
}

export const getIssuersList = (productsList) => {
  let issuers = {}
  productsList.forEach((el) => {
    if (el.issuerCode != 'PIT') {
      issuers[el.issuerCode] = el.issuerName
    }
  })
  return issuers
}
